import { ComponentFactoryResolver, ComponentRef, Inject, Injectable, ViewContainerRef } from '@angular/core';

@Injectable()
export class DynamicallyAddComponentService {

  private rootViewContainer: ViewContainerRef;

  constructor(
    @Inject(ComponentFactoryResolver) private factoryResolver: ComponentFactoryResolver
  ) {
  }

  setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  createDynamicComponent(componentToAdd: any): ComponentRef<{ }> {
    this.rootViewContainer.clear();
    const factory = this.factoryResolver.resolveComponentFactory(componentToAdd);

    return this.rootViewContainer.createComponent(factory);
  }

}
